exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-MFA-access-request-access-request-styles__mobileWrapper button {\n  height: 4.8rem;\n  margin: 1.6rem auto!important;\n  width: 100%;\n  display: block;\n  max-width: 30rem;\n}\n", ""]);

// Exports
exports.locals = {
	"mobileWrapper": "src-MFA-access-request-access-request-styles__mobileWrapper"
};